import { render, staticRenderFns } from "./NotificationsBadge.vue?vue&type=template&id=2bd6036e"
import script from "./NotificationsBadge.vue?vue&type=script&lang=ts"
export * from "./NotificationsBadge.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports